import { render } from "./LandingPageMobileMenu.vue?vue&type=template&id=0a622c4c&scoped=true"
import script from "./LandingPageMobileMenu.vue?vue&type=script&lang=js"
export * from "./LandingPageMobileMenu.vue?vue&type=script&lang=js"

import "./LandingPageMobileMenu.vue?vue&type=style&index=0&id=0a622c4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a622c4c"]])

export default __exports__